import { CommonModule, registerLocaleData } from '@angular/common';
import localeEN from '@angular/common/locales/en';
import localePL from '@angular/common/locales/pl';
import { Component, ViewChild, inject } from '@angular/core';
import { Network } from '@capacitor/network';
import { IonApp, IonModal, IonSpinner } from '@ionic/angular';
import { ConnectionStateService } from '@services/connection-state-service/connection-state.service';
import { PlatformService } from '@services/local/platform/platform.service';
import { NavigationService } from '@services/navigation/navigation.service';
import { UserIdleService } from '@services/user-idle/user-idle.service';
import { addIcons } from 'ionicons';
import { BehaviorSubject, defer, tap } from 'rxjs';
import { LoadingStateService } from 'src/app/services/loading-state/loading-state.service';
import { IONIC_BASE_UI_COMPONENTS } from './ionic-components-common/common-components';
import { IONIC_USED_ICONS } from './ionic-components-common/ionic-icons-imports';
registerLocaleData(localePL);
registerLocaleData(localeEN);

@Component({
    selector: 'medpace-app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [CommonModule, IonApp, IonSpinner, IonModal, ...IONIC_BASE_UI_COMPONENTS],
})
export class AppComponent {
    private loadingStateService = inject(LoadingStateService);
    private connectionStateService = inject(ConnectionStateService);
    private userIdleService = inject(UserIdleService);
    private navigationService = inject(NavigationService);

    @ViewChild(IonModal) modal: IonModal | undefined;
    isLoading$ = this.loadingStateService.getIsLoading();
    private platfrom = inject(PlatformService);
    deviceHasInternetConnectionSubject$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    isModalOpen: boolean = false;

    networkStatus$ = defer(() => Network.getStatus()).pipe(tap((result) => this.deviceHasInternetConnectionSubject$.next(result.connected)));

    openModal$ = this.deviceHasInternetConnectionSubject$.pipe(
        tap((hasConnection) => {
            this.connectionStateService.setConnectionState(hasConnection);
            if (hasConnection && this.modal && this.isModalOpen) {
                this.modal.dismiss().then(() => {
                    this.isModalOpen = false;
                });
            } else if (!hasConnection && this.modal && !this.isModalOpen) {
                this.modal.present().then(() => {
                    this.isModalOpen = true;
                });
            }
        })
    );

    constructor() {
        Network.addListener('networkStatusChange', (status) => {
            this.deviceHasInternetConnectionSubject$.next(status.connected);
        });

        addIcons(IONIC_USED_ICONS);

        this.navigationService.initializeBackButtonAction();
    }
}
